export default __webpack_public_path__ + "static/media/minus.10c31253.svg";